@if (!useSummaryView) {
  @if (!field.hidden) {
    <div animate.enter="fade-in" class="flex flex-col w-full mb-3">
      <div class="mb-2">
        <div class="leading-6 font-medium">{{ field.label | localize }}</div>
        @if (field.hint) {
          <div class="text-md text-secondary">{{ field.hint | localize }}</div>
        }
      </div>
      <!-- Aqui ira el contenedor del fichero -->
      <multifile-uploader-component [control]="field.control" [filePattern]="null" [embedded]="false"
        [min]="field.min" [max]="field.max" [extraPath]="field.extraPath" [acceptedExtensions]="field.extensions"
      [isComponentImage]="false"></multifile-uploader-component>
      @if (!field.readonly && field.control.touched && field.control.errors) {
        @if (field.control.errors.required) {
          <div class="text-sm text-warn leading-none font-medium mt-2">
            {{ 'errorRequiredField' | transloco }}
          </div>
        }
      }
    </div>
  }
}